import {
  VulnerabilitySeverity,
  ImageStatus,
  SecurityInsightsImageDigestsResponse,
  SecurityInsightsImageDetailsResponse,
  SecurityInsightsImagePackageVulnerabilityDetailsResponse,
  ImageScanStatus,
} from '@cast/types';

const imageDigestMap: Record<string, SecurityInsightsImageDigestsResponse> = {
  '31bd9c0d-f8f0-470e-a51c-f248481916a5': {
    items: [
      {
        digest:
          'sha256:72a84f690b9108dbbe8373d2efe8196e98db90894cc3aac241ef63439641bb74',
        architecture: 'amd64',
        status: ImageStatus.Running,
        scanStatus: ImageScanStatus.Pending,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-31d__',
        tags: [
          {
            name: 'k8s.gcr.io/cpvpa-amd64',
            version: 'v0.8.3',
            id: '31bd9c0d-f8f0-470e-a51c-f248481916a5',
          },
        ],
      },
    ],
  },
  '5b919665-3fbe-449a-b2e5-648cc9db8290': {
    items: [
      {
        digest:
          'sha256:528daf0f2947c6e72fa22d3baae662a4d749fcf2e688f58b412016107a69012f',
        architecture: 'amd64',
        status: ImageStatus.Running,
        scanStatus: ImageScanStatus.Completed,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-31d__',
        tags: [
          {
            name: 'us-docker.pkg.dev/castai-hub/library/agent',
            version: 'v0.28.0',
            id: '5b919665-3fbe-449a-b2e5-648cc9db8290',
          },
        ],
      },
      {
        digest:
          'sha256:9708fe371cf5c7ee610da8bf8f58f7f98ed35ecb0a75a00772c3fff04c4b8b7c',
        architecture: 'amd64',
        status: ImageStatus.NotRunning,
        scanStatus: ImageScanStatus.Completed,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-30d__',
        tags: [
          {
            name: 'us-docker.pkg.dev/castai-hub/library/agent:v0.10.0',
            id: '2a266a64-e0b8-4799-9b67-8c4914cb0008',
          },
        ],
      },
    ],
  },
  '2a266a64-e0b8-4799-9b67-8c4914cb0008': {
    items: [
      {
        digest:
          'sha256:528daf0f2947c6e72fa22d3baae662a4d749fcf2e688f58b412016107a69012f',
        architecture: 'amd64',
        status: ImageStatus.Running,
        scanStatus: ImageScanStatus.Failed,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-31d__',
        tags: [
          {
            name: 'us-docker.pkg.dev/castai-hub/library/agent',
            version: 'v0.28.0',
            id: '5b919665-3fbe-449a-b2e5-648cc9db8290',
          },
        ],
      },
      {
        digest:
          'sha256:9708fe371cf5c7ee610da8bf8f58f7f98ed35ecb0a75a00772c3fff04c4b8b7c',
        architecture: 'amd64',
        status: ImageStatus.NotRunning,
        scanStatus: ImageScanStatus.Completed,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-30d__',
        tags: [
          {
            name: 'us-docker.pkg.dev/castai-hub/library/agent',
            version: 'v0.10.0',
            id: '2a266a64-e0b8-4799-9b67-8c4914cb0008',
          },
        ],
      },
    ],
  },
  'b889c6e6-f90f-426c-8130-d172f4d0f156': {
    items: [
      {
        digest:
          'sha256:cb2313ddaa36a826ad8cc404443948dc8ec867a4b078890dc93c8593bbab697a',
        architecture: 'amd64',
        status: ImageStatus.Running,
        scanStatus: ImageScanStatus.Completed,
        vulnerabilities: 4,
        createdAt: '__TIMESTAMP:-31d__',
        tags: [
          {
            name: 'us-docker.pkg.dev/castai-hub/library/evictor',
            version: '929cd5882eb7300a537a0fd96fec847403074cdc',
            id: 'b889c6e6-f90f-426c-8130-d172f4d0f156',
          },
        ],
      },
    ],
  },
};

export const getImageDigests = (tagId: string) => {
  return imageDigestMap[tagId];
};

const imageDetailMap: Record<string, SecurityInsightsImageDetailsResponse> = {
  '31bd9c0d-f8f0-470e-a51c-f248481916a5': {
    architecture: 'amd64',
    tags: [
      {
        name: 'registry.k8s.io/cpa/cpvpa:v0.8.4',
        id: '31bd9c0d-f8f0-470e-a51c-f248481916a5',
      },
    ],
    layers: [
      {
        digest:
          'sha256:8a49fdb3b6a5ff2bd8ec6a86c05b2922a0f7454579ecc07637e94dfd1d0639b6',
        command: 'bazel build ...',
        size: '804073',
      },
      {
        digest:
          'sha256:7accb1b90d09e684da0fb1310b666506fde92d6bd5b32a05f7f0fa6495a3f236',
        command:
          '/bin/sh -c #(nop) ADD file:e204c3090208430d2fbf0da05e572c522c68d0464a0e163f665796fcad76ff44 in /cpvpa ',
        size: '14286826',
      },
      {
        digest: '',
        command: '/bin/sh -c #(nop)  ENTRYPOINT ["/cpvpa"]',
        size: '0',
      },
    ],
    digest:
      'sha256:72a84f690b9108dbbe8373d2efe8196e98db90894cc3aac241ef63439641bb74',
    lastSeen: '__TIMESTAMP:-31d__',
    bases: [],
    clusters: 1,
    status: ImageStatus.Running,
    scanStatus: ImageScanStatus.Completed,
    size: '15090899',
    vulnerabilities: {
      critical: 1,
      high: 1,
      low: 1,
      medium: 1,
      none: 0,
    },
  },
  '5b919665-3fbe-449a-b2e5-648cc9db8290': {
    architecture: 'amd64',
    tags: [
      {
        name: 'us-docker.pkg.dev/castai-hub/library/agent:v0.28.0',
        id: '5b919665-3fbe-449a-b2e5-648cc9db8290',
      },
    ],
    layers: [
      {
        digest:
          'sha256:8a49fdb3b6a5ff2bd8ec6a86c05b2922a0f7454579ecc07637e94dfd1d0639b6',
        command:
          '/bin/sh -c #(nop) ADD file:7625ddfd589fb824ee39f1b1eb387b98f3676420ff52f26eb9d975151e889667 in / ',
        size: '3397490',
      },
      {
        digest: '',
        command: '/bin/sh -c #(nop)  CMD ["/bin/sh"]',
        size: '0',
      },
      {
        digest: '',
        command: 'ARG TARGETARCH',
        size: '0',
      },
      {
        digest:
          'sha256:7accb1b90d09e684da0fb1310b666506fde92d6bd5b32a05f7f0fa6495a3f236',
        command:
          'COPY bin/castai-agent-amd64 /usr/local/bin/castai-agent # buildkit',
        size: '14087132',
      },
      {
        digest: '',
        command: 'CMD ["castai-agent"]',
        size: '0',
      },
    ],
    digest:
      'sha256:528daf0f2947c6e72fa22d3baae662a4d749fcf2e688f58b412016107a69012f',
    lastSeen: '__TIMESTAMP:-31d__',
    bases: [],
    clusters: 1,
    status: ImageStatus.Running,
    scanStatus: ImageScanStatus.Completed,
    size: '17484622',
    vulnerabilities: {
      critical: 1,
      high: 1,
      low: 1,
      medium: 1,
      none: 0,
    },
  },
  '2a266a64-e0b8-4799-9b67-8c4914cb0008': {
    architecture: 'amd64',
    tags: [
      {
        name: 'us-docker.pkg.dev/castai-hub/library/agent:v0.10.0',
        id: '2a266a64-e0b8-4799-9b67-8c4914cb0008',
      },
    ],
    layers: [
      {
        digest:
          'sha256:8a49fdb3b6a5ff2bd8ec6a86c05b2922a0f7454579ecc07637e94dfd1d0639b6',
        command:
          '/bin/sh -c #(nop) ADD file:7625ddfd589fb824ee39f1b1eb387b98f3676420ff52f26eb9d975151e889667 in / ',
        size: '3397490',
      },
      {
        digest: '',
        command: '/bin/sh -c #(nop)  CMD ["/bin/sh"]',
        size: '0',
      },
      {
        digest: '',
        command: 'ARG TARGETARCH',
        size: '0',
      },
      {
        digest:
          'sha256:7accb1b90d09e684da0fb1310b666506fde92d6bd5b32a05f7f0fa6495a3f236',
        command:
          'COPY bin/castai-agent-amd64 /usr/local/bin/castai-agent # buildkit',
        size: '14087132',
      },
      {
        digest: '',
        command: 'CMD ["castai-agent"]',
        size: '0',
      },
    ],
    digest:
      'sha256:528daf0f2947c6e72fa22d3baae662a4d749fcf2e688f58b412016107a69012f',
    lastSeen: '__TIMESTAMP:-7d__',
    bases: [],
    clusters: 1,
    status: ImageStatus.NotRunning,
    scanStatus: ImageScanStatus.Completed,
    size: '10584622',
    vulnerabilities: {
      critical: 1,
      high: 1,
      low: 1,
      medium: 1,
      none: 0,
    },
  },
  'b889c6e6-f90f-426c-8130-d172f4d0f156': {
    architecture: 'amd64',
    tags: [
      {
        name: 'us-docker.pkg.dev/castai-hub/library/evictor:929cd5882eb7300a537a0fd96fec847403074cdc',
        id: 'b889c6e6-f90f-426c-8130-d172f4d0f156',
      },
    ],
    layers: [
      {
        digest:
          'sha256:8a49fdb3b6a5ff2bd8ec6a86c05b2922a0f7454579ecc07637e94dfd1d0639b6',
        command:
          '/bin/sh -c #(nop) ADD file:7625ddfd589fb824ee39f1b1eb387b98f3676420ff52f26eb9d975151e889667 in / ',
        size: '3397490',
      },
      {
        digest: '',
        command: '/bin/sh -c #(nop)  CMD ["/bin/sh"]',
        size: '0',
      },
      {
        digest: '',
        command: 'ARG TARGETARCH',
        size: '0',
      },
      {
        digest:
          'sha256:7accb1b90d09e684da0fb1310b666506fde92d6bd5b32a05f7f0fa6495a3f236',
        command: 'COPY bin/evictor /usr/local/bin/evictor # buildkit',
        size: '14087132',
      },
      {
        digest: '',
        command: 'CMD ["evictor"]',
        size: '0',
      },
    ],
    digest:
      'sha256:528daf0f2947c6e72fa22d3baae662a4d749fcf2e688f58b412016107a69012f',
    lastSeen: '__TIMESTAMP:-31d__',
    bases: [],
    clusters: 1,
    status: ImageStatus.Running,
    scanStatus: ImageScanStatus.Completed,
    size: '17484622',
    vulnerabilities: {
      critical: 1,
      high: 1,
      low: 1,
      medium: 1,
      none: 0,
    },
  },
};

export const getImageDetails = (tagId: string) => {
  const details = imageDetailMap[tagId];
  return {
    ...details,
    bases: [
      {
        sharedLayers: Math.floor(details.layers!.length / 2),
        tag: {
          name: 'alpine:3',
          id: 'e1b91b75-f137-4c18-8c5f-252183c39131',
        },
        digest:
          'sha256:1304f174557314a7ed9eddb4eab12fed12cb0cd9809e4c28f29af86979a3c870',
      },
    ],
  };
};

const imageVulnerabilitiesMap: Record<
  string,
  SecurityInsightsImagePackageVulnerabilityDetailsResponse
> = {
  'f62599a1-f063-48b7-8c95-3c160ed427e9': {
    id: 'f62599a1-f063-48b7-8c95-3c160ed427e9',
    cwes: ['CWE-770'],
    severityLevel: VulnerabilitySeverity.high,
    cvss: {
      nvd: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H',
        scorev3: 7.5,
      },
      redhat: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:N/I:N/A:H',
        scorev3: 6.5,
      },
    },
    defaultSource: 'nvd',
    title: 'Possible DoS translating ASN.1 object identifiers',
    description:
      "Issue summary: Processing some specially crafted ASN.1 object identifiers or\ndata containing them may be very slow.\n\nImpact summary: Applications that use OBJ_obj2txt() directly, or use any of\nthe OpenSSL subsystems OCSP, PKCS7/SMIME, CMS, CMP/CRMF or TS with no message\nsize limit may experience notable to very long delays when processing those\nmessages, which may lead to a Denial of Service.\n\nAn OBJECT IDENTIFIER is composed of a series of numbers - sub-identifiers -\nmost of which have no size limit.  OBJ_obj2txt() may be used to translate\nan ASN.1 OBJECT IDENTIFIER given in DER encoding form (using the OpenSSL\ntype ASN1_OBJECT) to its canonical numeric text form, which are the\nsub-identifiers of the OBJECT IDENTIFIER in decimal form, separated by\nperiods.\n\nWhen one of the sub-identifiers in the OBJECT IDENTIFIER is very large\n(these are sizes that are seen as absurdly large, taking up tens or hundreds\nof KiBs), the translation to a decimal number in text may take a very long\ntime.  The time complexity is O(n^2) with 'n' being the size of the\nsub-identifiers in bytes (*).\n\nWith OpenSSL 3.0, support to fetch cryptographic algorithms using names /\nidentifiers in string form was introduced.  This includes using OBJECT\nIDENTIFIERs in canonical numeric text form as identifiers for fetching\nalgorithms.\n\nSuch OBJECT IDENTIFIERs may be received through the ASN.1 structure\nAlgorithmIdentifier, which is commonly used in multiple protocols to specify\nwhat cryptographic algorithm should be used to sign or verify, encrypt or\ndecrypt, or digest passed data.\n\nApplications that call OBJ_obj2txt() directly with untrusted data are\naffected, with any version of OpenSSL.  If the use is for the mere purpose\nof display, the severity is considered low.\n\nIn OpenSSL 3.0 and newer, this affects the subsystems OCSP, PKCS7/SMIME,\nCMS, CMP/CRMF or TS.  It also impacts anything that processes X.509\ncertificates, including simple things like verifying its signature.\n\nThe impact on TLS is relatively low, because all versions of OpenSSL have a\n100KiB limit on the peer's certificate chain.  Additionally, this only\nimpacts clients, or servers that have explicitly enabled client\nauthentication.\n\nIn OpenSSL 1.1.1 and 1.0.2, this only affects displaying diverse objects,\nsuch as X.509 certificates.  This is assumed to not happen in such a way\nthat it would cause a Denial of Service, so these versions are considered\nnot affected by this issue in such a way that it would be cause for concern,\nand the severity is therefore considered low.",
    affectedVersion: '',
    patchedVersion: '3.1.1-r0',
    package: {
      name: 'apt',
      source: 'debian',
      version: '1.4.9',
      paths: [
        '/usr/bin/apt',
        '/usr/bin/apt-cache',
        '/usr/bin/apt-cdrom',
        '/usr/bin/apt-config',
        '/usr/bin/apt-get',
        '/usr/bin/apt-key',
        '/usr/bin/apt-mark',
      ],
    },
    sources: [
      'http://www.openwall.com/lists/oss-security/2023/05/30/1',
      'https://access.redhat.com/errata/RHSA-2023:3722',
      'https://access.redhat.com/security/cve/CVE-2023-2650',
      'https://bugzilla.redhat.com/2181082',
      'https://bugzilla.redhat.com/2182561',
      'https://bugzilla.redhat.com/2182565',
      'https://bugzilla.redhat.com/2188461',
      'https://bugzilla.redhat.com/2207947',
      'https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2023-2650',
      'https://errata.almalinux.org/9/ALSA-2023-3722.html',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=423a2bc737a908ad0c77bda470b2b59dc879936b',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=853c5e56ee0b8650c73140816bb8b91d6163422c',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=9e209944b35cf82368071f160a744b6178f9b098',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=db779b0e10b047f2585615e0b8f2acdf21f8544a',
      'https://linux.oracle.com/cve/CVE-2023-2650.html',
      'https://linux.oracle.com/errata/ELSA-2023-3722.html',
      'https://lists.debian.org/debian-lts-announce/2023/06/msg00011.html',
      'https://nvd.nist.gov/vuln/detail/CVE-2023-2650',
      'https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2023-0009',
      'https://security.netapp.com/advisory/ntap-20230703-0001/',
      'https://ubuntu.com/security/notices/USN-6119-1',
      'https://ubuntu.com/security/notices/USN-6188-1',
      'https://www.cve.org/CVERecord?id=CVE-2023-2650',
      'https://www.debian.org/security/2023/dsa-5417',
      'https://www.openssl.org/news/secadv/20230530.txt',
    ],
  },
  '78c0e99f-d8aa-421a-8de2-5b2ae73b5f91': {
    id: '78c0e99f-d8aa-421a-8de2-5b2ae73b5f91',
    cwes: ['CWE-770'],
    severityLevel: VulnerabilitySeverity.high,
    cvss: {
      nvd: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H',
        scorev3: 7.5,
      },
      redhat: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:N/I:N/A:H',
        scorev3: 6.5,
      },
    },
    defaultSource: 'nvd',
    title: 'Possible DoS translating ASN.1 object identifiers',
    description:
      "Issue summary: Processing some specially crafted ASN.1 object identifiers or\ndata containing them may be very slow.\n\nImpact summary: Applications that use OBJ_obj2txt() directly, or use any of\nthe OpenSSL subsystems OCSP, PKCS7/SMIME, CMS, CMP/CRMF or TS with no message\nsize limit may experience notable to very long delays when processing those\nmessages, which may lead to a Denial of Service.\n\nAn OBJECT IDENTIFIER is composed of a series of numbers - sub-identifiers -\nmost of which have no size limit.  OBJ_obj2txt() may be used to translate\nan ASN.1 OBJECT IDENTIFIER given in DER encoding form (using the OpenSSL\ntype ASN1_OBJECT) to its canonical numeric text form, which are the\nsub-identifiers of the OBJECT IDENTIFIER in decimal form, separated by\nperiods.\n\nWhen one of the sub-identifiers in the OBJECT IDENTIFIER is very large\n(these are sizes that are seen as absurdly large, taking up tens or hundreds\nof KiBs), the translation to a decimal number in text may take a very long\ntime.  The time complexity is O(n^2) with 'n' being the size of the\nsub-identifiers in bytes (*).\n\nWith OpenSSL 3.0, support to fetch cryptographic algorithms using names /\nidentifiers in string form was introduced.  This includes using OBJECT\nIDENTIFIERs in canonical numeric text form as identifiers for fetching\nalgorithms.\n\nSuch OBJECT IDENTIFIERs may be received through the ASN.1 structure\nAlgorithmIdentifier, which is commonly used in multiple protocols to specify\nwhat cryptographic algorithm should be used to sign or verify, encrypt or\ndecrypt, or digest passed data.\n\nApplications that call OBJ_obj2txt() directly with untrusted data are\naffected, with any version of OpenSSL.  If the use is for the mere purpose\nof display, the severity is considered low.\n\nIn OpenSSL 3.0 and newer, this affects the subsystems OCSP, PKCS7/SMIME,\nCMS, CMP/CRMF or TS.  It also impacts anything that processes X.509\ncertificates, including simple things like verifying its signature.\n\nThe impact on TLS is relatively low, because all versions of OpenSSL have a\n100KiB limit on the peer's certificate chain.  Additionally, this only\nimpacts clients, or servers that have explicitly enabled client\nauthentication.\n\nIn OpenSSL 1.1.1 and 1.0.2, this only affects displaying diverse objects,\nsuch as X.509 certificates.  This is assumed to not happen in such a way\nthat it would cause a Denial of Service, so these versions are considered\nnot affected by this issue in such a way that it would be cause for concern,\nand the severity is therefore considered low.",
    affectedVersion: '',
    patchedVersion: '3.1.1-r0',
    package: {
      name: 'apt',
      source: 'debian',
      version: '1.4.9',
      paths: [
        '/usr/bin/apt',
        '/usr/bin/apt-cache',
        '/usr/bin/apt-cdrom',
        '/usr/bin/apt-config',
        '/usr/bin/apt-get',
        '/usr/bin/apt-key',
        '/usr/bin/apt-mark',
      ],
    },
    sources: [
      'http://www.openwall.com/lists/oss-security/2023/05/30/1',
      'https://access.redhat.com/errata/RHSA-2023:3722',
      'https://access.redhat.com/security/cve/CVE-2023-2650',
      'https://bugzilla.redhat.com/2181082',
      'https://bugzilla.redhat.com/2182561',
      'https://bugzilla.redhat.com/2182565',
      'https://bugzilla.redhat.com/2188461',
      'https://bugzilla.redhat.com/2207947',
      'https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2023-2650',
      'https://errata.almalinux.org/9/ALSA-2023-3722.html',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=423a2bc737a908ad0c77bda470b2b59dc879936b',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=853c5e56ee0b8650c73140816bb8b91d6163422c',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=9e209944b35cf82368071f160a744b6178f9b098',
      'https://git.openssl.org/gitweb/?p=openssl.git;a=commitdiff;h=db779b0e10b047f2585615e0b8f2acdf21f8544a',
      'https://linux.oracle.com/cve/CVE-2023-2650.html',
      'https://linux.oracle.com/errata/ELSA-2023-3722.html',
      'https://lists.debian.org/debian-lts-announce/2023/06/msg00011.html',
      'https://nvd.nist.gov/vuln/detail/CVE-2023-2650',
      'https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2023-0009',
      'https://security.netapp.com/advisory/ntap-20230703-0001/',
      'https://ubuntu.com/security/notices/USN-6119-1',
      'https://ubuntu.com/security/notices/USN-6188-1',
      'https://www.cve.org/CVERecord?id=CVE-2023-2650',
      'https://www.debian.org/security/2023/dsa-5417',
      'https://www.openssl.org/news/secadv/20230530.txt',
    ],
  },
  'bcf8ba92-e416-43fd-906b-dd7c5c8db3ab': {
    id: 'bcf8ba92-e416-43fd-906b-dd7c5c8db3ab',
    cwes: ['CWE-327'],
    severityLevel: VulnerabilitySeverity.medium,
    cvss: {
      ghsa: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:C/C:H/I:N/A:N',
        scorev3: 5.6,
      },
      nvd: {
        vectorv2: 'AV:L/AC:L/Au:N/C:P/I:N/A:N',
        scorev2: 2.1,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:C/C:H/I:N/A:N',
        scorev3: 5.6,
      },
      redhat: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:C/C:H/I:N/A:N',
        scorev3: 5.6,
      },
    },
    defaultSource: 'nvd',
    title:
      'aws/aws-sdk-go: CBC padding oracle issue in AWS S3 Crypto SDK for golang',
    description:
      "A padding oracle vulnerability exists in the AWS S3 Crypto SDK for GoLang versions prior to V2. The SDK allows users to encrypt files with AES-CBC without computing a Message Authentication Code (MAC), which then allows an attacker who has write access to the target's S3 bucket and can observe whether or not an endpoint with access to the key can decrypt a file, they can reconstruct the plaintext with (on average) 128*length (plaintext) queries to the endpoint, by exploiting CBC's ability to manipulate the bytes of the next block and PKCS5 padding errors. It is recommended to update your SDK to V2 or later, and re-encrypt your files.",
    affectedVersion: '',
    patchedVersion: '',
    sources: [
      'https://access.redhat.com/security/cve/CVE-2020-8911',
      'https://aws.amazon.com/blogs/developer/updates-to-the-amazon-s3-encryption-client/?s=09',
      'https://bugzilla.redhat.com/show_bug.cgi?id=1869800',
      'https://github.com/advisories/GHSA-f5pg-7wfw-84q9',
      'https://github.com/aws/aws-sdk-go/commit/1e84382fa1c0086362b5a4b68e068d4f8518d40e',
      'https://github.com/aws/aws-sdk-go/commit/ae9b9fd92af132cfd8d879809d8611825ba135f4',
      'https://github.com/aws/aws-sdk-go/pull/3403',
      'https://github.com/google/security-research/security/advisories/GHSA-f5pg-7wfw-84q9',
      'https://github.com/sophieschmieg/exploits/tree/master/aws_s3_crypto_poc',
      'https://nvd.nist.gov/vuln/detail/CVE-2020-8911',
      'https://pkg.go.dev/vuln/GO-2022-0646',
      'https://www.cve.org/CVERecord?id=CVE-2020-8911',
    ],
  },
  '9b2259c7-ae61-4f0d-9365-2c1fe8954408': {
    id: '9b2259c7-ae61-4f0d-9365-2c1fe8954408',
    cwes: ['CWE-327'],
    severityLevel: VulnerabilitySeverity.low,
    cvss: {
      ghsa: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:U/C:L/I:N/A:N',
        scorev3: 2.5,
      },
      nvd: {
        vectorv2: 'AV:L/AC:L/Au:N/C:P/I:N/A:N',
        scorev2: 2.1,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:U/C:L/I:N/A:N',
        scorev3: 2.5,
      },
      redhat: {
        vectorv2: '',
        scorev2: 0,
        vectorv3: 'CVSS:3.1/AV:L/AC:H/PR:L/UI:N/S:U/C:L/I:N/A:N',
        scorev3: 2.5,
      },
    },
    defaultSource: 'nvd',
    title:
      'aws-sdk-go: In-band key negotiation issue in AWS S3 Crypto SDK for golang',
    description:
      'A vulnerability in the in-band key negotiation exists in the AWS S3 Crypto SDK for GoLang versions prior to V2. An attacker with write access to the targeted bucket can change the encryption algorithm of an object in the bucket, which can then allow them to change AES-GCM to AES-CTR. Using this in combination with a decryption oracle can reveal the authentication key used by AES-GCM as decrypting the GMAC tag leaves the authentication key recoverable as an algebraic equation. It is recommended to update your SDK to V2 or later, and re-encrypt your files.',
    affectedVersion: '',
    patchedVersion: '',
    sources: [
      'https://access.redhat.com/security/cve/CVE-2020-8912',
      'https://aws.amazon.com/blogs/developer/updates-to-the-amazon-s3-encryption-client/?s=09',
      'https://bugzilla.redhat.com/show_bug.cgi?id=1869801',
      'https://github.com/advisories/GHSA-7f33-f4f5-xwgw',
      'https://github.com/aws/aws-sdk-go/commit/1e84382fa1c0086362b5a4b68e068d4f8518d40e',
      'https://github.com/aws/aws-sdk-go/commit/ae9b9fd92af132cfd8d879809d8611825ba135f4',
      'https://github.com/aws/aws-sdk-go/pull/3403',
      'https://github.com/google/security-research/security/advisories/GHSA-7f33-f4f5-xwgw',
      'https://github.com/sophieschmieg/exploits/tree/master/aws_s3_crypto_poc',
      'https://nvd.nist.gov/vuln/detail/CVE-2020-8912',
      'https://pkg.go.dev/vuln/GO-2022-0646',
      'https://www.cve.org/CVERecord?id=CVE-2020-8912',
    ],
  },
};

export const getImageVulnerabilityDetails = (packageId: string) => {
  return imageVulnerabilitiesMap[packageId];
};
